import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('product_set_status')
@doc.path('/product_set_statuses/{?id}')
export default class ProductSetStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_ProductSetStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
		'label': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_ProductSetStatusReference;

	public get color() {
		switch (this.reference) {
			case 'enabled':
				return 'green';
			case 'disabled':
				return 'red';
		}
	}
}
